import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const CircleClose = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/close-circle">
        <g id="close-circle">
          <path
            id="Vector"
            d="M7.9987 15.1667C4.04536 15.1667 0.832031 11.9534 0.832031 8.00004C0.832031 4.04671 4.04536 0.833374 7.9987 0.833374C11.952 0.833374 15.1654 4.04671 15.1654 8.00004C15.1654 11.9534 11.952 15.1667 7.9987 15.1667ZM7.9987 1.83337C4.5987 1.83337 1.83203 4.60004 1.83203 8.00004C1.83203 11.4 4.5987 14.1667 7.9987 14.1667C11.3987 14.1667 14.1654 11.4 14.1654 8.00004C14.1654 4.60004 11.3987 1.83337 7.9987 1.83337Z"
          />
          <path
            id="Vector_2"
            d="M6.11161 10.3867C5.98495 10.3867 5.85828 10.34 5.75828 10.24C5.56495 10.0467 5.56495 9.72666 5.75828 9.53332L9.53162 5.75999C9.72495 5.56666 10.0449 5.56666 10.2383 5.75999C10.4316 5.95332 10.4316 6.27332 10.2383 6.46666L6.46495 10.24C6.37161 10.34 6.23828 10.3867 6.11161 10.3867Z"
          />
          <path
            id="Vector_3"
            d="M9.88495 10.3867C9.75828 10.3867 9.63162 10.34 9.53162 10.24L5.75828 6.46666C5.56495 6.27332 5.56495 5.95332 5.75828 5.75999C5.95161 5.56666 6.27161 5.56666 6.46495 5.75999L10.2383 9.53332C10.4316 9.72666 10.4316 10.0467 10.2383 10.24C10.1383 10.34 10.0116 10.3867 9.88495 10.3867Z"
          />
        </g>
      </g>
    </svg>
  );
};

CircleClose.displayName = 'CircleClose';
